export default "__VITE_ASSET__CE6qN0AE__"